import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom"; // para leer el token de la URL
import { Formik } from "formik";
import * as Yup from "yup";
import InputIcon from "../../components/InputIcon/InputIcon"
import Boton from "../../components/Boton/Boton";
import * as Iconsax from "iconsax-react";
import useUsuario from "../../hooks/useUsuario";
import { Button } from "primereact/button";
import { useLocation,useNavigate } from "react-router-dom";
import Slider from "../../components/slider/Slider";
import "../../components/Inicio/FormsEva.scss"
import "./Login.scss";
import * as constantes from "../../constants/constantes";

const ENDPOINT = constantes.URLAPI;

export default function RestableceClave() {
    
    const [passwordType, setpasswordType] = useState("password");    
    const [modalOpen, setModalOpen] = useState(false);  // Estado para abrir/cerrar el modal
    const [correo, setCorreo] = useState("");  // Estado para el correo en el modal
    const [mensajeError, setMensajeError] = useState("");  // Mensaje de error en el modal
    const [isResetSuccess, setIsResetSuccess] = useState(false); // Asegúrate de declararlo
    const { isloginLoading,hasLoginError,login, isLogged } = useUsuario();
    const [codigoColaborador, setCodigoColaborador] = useState("");
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    
    const token = searchParams.get("token"); // Token desde la URL
  
    const handleSubmit = (e) =>{
        e.preventDefault()
        login()
    };
    // const schema = Yup.object().shape({
    //     username: Yup.string().required("El código de colaborador es un campo obligatorio"),        
    //     password: Yup.string().required("Contraseña es un campo obligatorio").min(5, "La contraseña debe tener al menos 5 caracteres"),
    // });
    
    const togglePassword = () => {
        if (passwordType === "password") {
            setpasswordType("text");
            return;
        }
        setpasswordType("password");
    };

    //const Logarse = async(userName,password,setSubmitting)=>{       
    //    await login({ userName, password},()=>setSubmitting(false));        
    //}

    const cambiarPassword = async (password, token, setSubmitting) => {
        try {
            const response = await fetch(`${ENDPOINT}/Usuario/LoginClave`,{            
            //const response = await fetch("http://localhost:7152/api/LoginClave", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ password, token }),
            });

            if (response.ok) {
                setIsResetSuccess(true);
                setMensajeError("");
                setTimeout(() => {
                    navigate("/Login"); // <-- Redirige al Login después de 2 segundos 
                }, 2000);
            } else {
                const data = await response.json();
                setMensajeError(data.message || "Error al cambiar la contraseña");
            }
        } catch (error) {
            setMensajeError("Error de conexión con el servidor");
        } finally {
            setSubmitting(false);
        }
    };

    const schema = Yup.object().shape({
        password: Yup.string()
            .required("Contraseña es obligatoria")
            .min(6, "Debe tener al menos 6 caracteres"),
        confirmaPassword: Yup.string()
            .required("Confirmar contraseña es obligatoria")
            .oneOf([Yup.ref("password")], "Las contraseñas no coinciden"),
    });

    return (
        <div className="restablecer-clave-container">
             {/* Formulario de login */}
            <Formik
                initialValues={{ password: "", confirmaPassword: "" }}                
                validationSchema={schema}                
                onSubmit={(values,{ setSubmitting }) => {

                    cambiarPassword(values.password, token, setSubmitting);                  

                }}
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting,setSubmitting }) => (
                    <form onSubmit={handleSubmit}>
                        <div>
                            <Slider/>
                                <div className="card contentLogin">
                                
                                    <div className="text-center form-img">
                                        <img src="images/login/logo_INLEARNING.png" alt="hyper" width={365} />
                                    </div>
                                    
                                    <div className="form-login">
                                        <div className="text-center"><h4 classname="text-center">Restablecer Contraseña</h4><br></br></div>
                                        <label htmlFor="Password" className="peva-label">
                                            Ingresar una Nueva contraseña
                                        </label>
                                        <div className="peva-input-icon">
                                            <InputIcon
                                                id="Password"
                                                type={passwordType}
                                                className = "grey"
                                                placeholder="Escribe aquí"
                                                name="password"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                icon={passwordType === "password"?<Iconsax.EyeSlash /> : <Iconsax.Eye />}
                                                onClickIcon={togglePassword}
                                                width="100%"
                                                height={48}
                                            />                                            
                                            {errors.password && touched.password && (
                                                  <p className="error">{errors.password}</p>
                                            )}
                                        </div>

                                        <label htmlFor="confirmaPassword" className="peva-label">
                                            Confirmar Contraseña
                                        </label>
                                        <div className="peva-input-icon">
                                            <InputIcon
                                                id="confirmaPassword"
                                                type={passwordType}
                                                className="grey"
                                                placeholder="Escribe aquí"
                                                name="confirmaPassword"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                icon={
                                                    passwordType === "password" ? (
                                                        <Iconsax.EyeSlash />
                                                    ) : (
                                                        <Iconsax.Eye />
                                                    )
                                                }
                                                onClickIcon={togglePassword}
                                                width="100%"
                                                height={48}
                                            />
                                            {errors.confirmaPassword && touched.confirmaPassword && (
                                                <p className="error">{errors.confirmaPassword}</p>
                                            )}
                                        </div>

                                        {mensajeError && <p className="error">{mensajeError}</p>}
                                        {isResetSuccess && (
                                                <p className="success">¡Contraseña actualizada con éxito!</p>
                                        )}
                                        
                                        <div className="form-footer">
                                            <Boton nombre={"Guardar"} color="secondary" widths="100%" type="submit" loading={isSubmitting}></Boton>
                                        </div>                                                                            
                                        
                                    </div>
                                </div>

                        </div>

                        {/* </div> */}
                    </form>
                )}
            </Formik>            
        </div>        
    );
}

//export default Login;
